// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1foAc","obliqueLineWrap":"membershipbadge_obliqueLineWrap__G_1c8","obliqueLine":"membershipbadge_obliqueLine__vuPTH"};